import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
import { testimonialAvatars } from '../data/avatars';
const testimonials = [{
  name: 'Laura',
  location: 'Córdoba, Argentina',
  avatar: testimonialAvatars[0],
  text: 'No sabía pintar ni dibujar, pero con las plantillas pude empezar tranquila. Hice mis primeros portavelas y quedaron hermosos.'
}, {
  name: 'Mariana',
  location: 'Bogotá, Colombia',
  avatar: testimonialAvatars[1],
  text: 'Me encantó porque no necesitas comprar mil cosas. Empecé con frascos que tenía en casa y ahora estoy probando diseños para regalar.'
}, {
  name: 'Valeria',
  location: 'Ciudad de México, México',
  avatar: testimonialAvatars[2],
  text: 'Lo compré como hobby, pero cuando subí mis primeras piezas a Instagram varias personas me preguntaron si las vendía.'
}, {
  name: 'Sofía',
  location: 'Lima, Perú',
  avatar: testimonialAvatars[3],
  text: 'La guía es clara y práctica. Me ayudó a entender materiales, errores y cómo hacer que las piezas se vean más prolijas.'
}];
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const go = (dir: number) => {
    setDirection(dir);
    setIndex(prev => (prev + dir + testimonials.length) % testimonials.length);
  };
  const current = testimonials[index];
  return <section className="bg-deco-cream py-14 sm:py-20 px-4 sm:px-6 lg:px-8" data-id="element-212" data-mp="zyseai0frsv6">
      <div className="max-w-2xl mx-auto" data-id="element-213" data-mp="14ur5seh29qzt">
        <p className="text-center text-[10px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-deco-brick mb-4" data-id="element-214" data-mp="q6wg76yco2qy">
          Testimonios
        </p>
        <h2 className="text-center font-serif text-2xl sm:text-4xl text-deco-forest font-semibold mb-10" data-id="element-215" data-mp="v3wm9hv795i2">
          Lo probaron.{' '}
          <span className="italic text-deco-brick" data-id="element-216" data-mp="1nlqqh3hiwena">Les encantó.</span>
        </h2>

        <div className="relative bg-deco-aqua-soft rounded-[2rem] px-6 py-10 sm:px-14 sm:py-12 border border-deco-aqua/40 overflow-hidden min-h-[300px] sm:min-h-[280px] flex items-center" style={{
        backgroundColor: "#FFFCF9",
        backgroundImage: "none"
      }} data-id="element-217" data-mp="1nnv62iosb23e">
          <AnimatePresence mode="wait" custom={direction} data-id="element-218" data-mp="1ofzsek1n7m05">
            <motion.figure key={index} custom={direction} initial={{
            opacity: 0,
            x: direction * 28
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: direction * -28
          }} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1]
          }} className="w-full flex flex-col items-center text-center" data-id="element-219" data-mp="1jihs1i1oyf3r">
              <img src={current.avatar} alt={current.name} className="w-16 h-16 rounded-full object-cover border-[3px] border-white shadow-sm mb-4" data-id="element-220" data-mp="14tlb0vhnprr0" />
              <div className="flex gap-0.5 mb-5" data-id="element-221" data-mp="vt6ndph800kc">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="text-deco-brick fill-deco-brick" data-id="element-222" data-mp="qtk9rexhcib0" data-mpi={j} />)}
              </div>
              <blockquote className="font-serif italic text-base sm:text-xl text-deco-forest leading-relaxed mb-6 max-w-lg" data-id="element-223" data-mp="32h5yef2ep5nx">
                “{current.text}”
              </blockquote>
              <figcaption data-id="element-224" data-mp="37hto8xewfggk">
                <span className="block font-semibold text-sm text-deco-forest" data-id="element-225" data-mp="3cek4bkqpec1z">
                  {current.name}
                </span>
                <span className="block text-[12px] text-deco-forest/55" data-id="element-226" data-mp="3gg5bcpgk3w49">
                  {current.location}
                </span>
              </figcaption>
            </motion.figure>
          </AnimatePresence>
        </div>

        <div className="flex items-center justify-center gap-4 mt-7" data-id="element-227" data-mp="2on4vra8c2yia">
          <button onClick={() => go(-1)} aria-label="Testimonio anterior" className="w-11 h-11 rounded-full bg-white border border-deco-aqua/50 text-deco-forest flex items-center justify-center hover:bg-deco-aqua hover:text-white hover:border-deco-aqua transition-colors duration-200" data-id="element-228" data-mp="2spjfdwjtu2am">
            <ChevronLeft size={18} data-id="element-229" data-mp="24z5kzzdrrrcv" />
          </button>

          <div className="flex items-center gap-2" data-id="element-230" data-mp="1lxomzh3td8e2">
            {testimonials.map((t, i) => <button key={t.name} onClick={() => {
            setDirection(i > index ? 1 : -1);
            setIndex(i);
          }} aria-label={`Ver testimonio de ${t.name}`} className={`h-2 rounded-full transition-all duration-200 ${i === index ? 'w-6 bg-deco-brick' : 'w-2 bg-deco-forest/20 hover:bg-deco-forest/40'}`} data-id="element-231" data-mp="1gz4x55m3ncgf" data-mpi={i} />)}
          </div>

          <button onClick={() => go(1)} aria-label="Siguiente testimonio" className="w-11 h-11 rounded-full bg-white border border-deco-aqua/50 text-deco-forest flex items-center justify-center hover:bg-deco-aqua hover:text-white hover:border-deco-aqua transition-colors duration-200" data-id="element-232" data-mp="2ejhrpw8o6x3h">
            <ChevronRight size={18} data-id="element-233" data-mp="2qw2054fqy89w" />
          </button>
        </div>
      </div>
    </section>;
}